import React from "react";

import type { MediaItem } from "../../media-widget/types/contexts";

interface MediaBackgroundProps {
  media: MediaItem;
}

const MediaBackground: React.FC<MediaBackgroundProps> = ({ media }) => {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      {media.type === "video" && (
        <video
          src={media.url}
          autoPlay
          loop
          muted
          playsInline
          className="absolute h-full w-full object-cover"
          style={{
            filter: "blur(8px) brightness(0.6)",
          }}
        />
      )}
      {media.type === "image" && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${media.url})`,
            filter: "blur(20px) brightness(0.3)",
          }}
        />
      )}
      <div className="absolute inset-0 bg-black/50" />
    </div>
  );
};

export default MediaBackground;
